import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useEventListener from "../../../hooks/event-handler";
import { getSStorage } from "../../../utils";

interface ItemsPays {
  id: number;
  country_name: string;
}
interface IobJectResponse {
  id: number;
  name: string;
  countries: Array<ItemsPays>;
}
interface IdataMake {
  idContinent: string;
  countrId: string;
  countryName: string;
}
export default function UseCompleteContryInvestor() {
  const history = useHistory();
  const [loader, setLoaderState] = useState<boolean>(true);
  const [allContinents, setallContinents] = useState<Array<IobJectResponse>>(
    []
  );
  const [paysChecked, setPaysChecked] = useState<Array<object>>(
    JSON.parse(getSStorage("pays_company_investor") || "[]")
  );
  const [allContinentSelected, setAllContinentSelected] = useState<
    Array<string>
  >([]);
  const [errorData, seterrorData] = useState<boolean>(false);
  const [dataCompleted, setDataCompleted] = useState(
    JSON.parse(getSStorage("completed_account") || "{}")
  );
  const transFormnData = (data: any) => {
    let custom = data.countryesData.map((el: any) => {
      let temp = {
        idContinent: data.idContinent,
        countrId: el && el.id,
        countryName: el && el.country_name,
      };
      return temp;
    });
    return custom;
  };

  const addPaysInArray = (data: any) => {
    //DATA CUSTOM
    let dataMake: Array<IdataMake> = [];
    //FIND IF PARAM IS ARRAY OF DATA , for add multiple
    if (data && data.countryesData) {
      //find if bouton is selected all is clicked
      let cotinentItemIsSelected = allContinentSelected?.find(
        (el) => el === data.idContinent
      );
      //tranform data if array
      let dataAfterTransform = transFormnData(data);
      dataMake = [...dataAfterTransform];

      //if selected all is not clicked
      if (!cotinentItemIsSelected) {
        //remove if item is existe deja
        let dataToStore = paysChecked?.filter(
          (el: any) => el.idContinent !== data.idContinent
        );

        //Performe data to store
        let transFormDataToStore = [...dataToStore, ...dataMake];
        //selecte all data
        setPaysChecked(transFormDataToStore);
        //active checked selected all is clicked
        setAllContinentSelected([...allContinentSelected, data.idContinent]);
      } else {
        //if all selected is clicked , remove all item same idContinent
        setPaysChecked(
          paysChecked?.filter((el: any) => el.idContinent !== data.idContinent)
        );
        //Make selected all is not clicked
        setAllContinentSelected(
          allContinentSelected?.filter((el) => el !== data.idContinent)
        );
      }
    } else {
      dataMake = [data];
      let found = paysChecked?.find((el: any) => el.countrId === data.countrId);
      if (!found) {
        setPaysChecked([...paysChecked, ...dataMake]);
      } else {
        setPaysChecked(
          paysChecked?.filter((elem: any) => elem.countrId != data.countrId)
        );
      }
    }
  };

  useEffect(() => {
    async function getContinent() {
      setallContinents(dataCompleted?.targetedCountry);
      setLoaderState(false);
    }
    getContinent();
    return () => {};
  }, []);

  const navigateTargetProgram = () => {
    if (paysChecked.length > 0) {
      sessionStorage.setItem(
        "pays_company_investor",
        JSON.stringify(paysChecked)
      );
      history.push("/complete-target-investor");
    } else {
      seterrorData(true);
    }
  };

  useEffect(() => {
    seterrorData(false);
    return () => {};
  }, [paysChecked]);

  const keyEnter = ({ key }: any) => {
    if (key == "Enter") {
      navigateTargetProgram();
    } else return;
  };

  useEventListener("keydown", keyEnter);

  return {
    navigateTargetProgram,
    addPaysInArray,
    paysChecked,
    allContinents,
    loader,
    allContinentSelected,
    errorData,
  };
}
